import { useEffect } from 'react'

/**
 * Fetching the product data
 */
export const useFetchAction = (fetchAction, param) => {
  useEffect(() => {
    param ? fetchAction(param) : fetchAction();
  }, []);
};